import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    OnInit,
    Signal,
    signal,
    WritableSignal,
} from '@angular/core';
import { Router } from '@angular/router';

import { RoutePathEnum } from '@connect-services/client/models/routes.model';
import { OrganizationAccessPermissionsService } from '@connect-services/client/services/organization-access-permissions.service';
import { SecurityService } from '@connect-services/client/services/security.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { Organization } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule],
    selector: 'app-organization',
    templateUrl: './organization.component.html',
})
export class OrganizationComponent implements OnInit {
    public readonly organization: WritableSignal<Organization | null> = signal(null);

    protected readonly ButtonType = ButtonType;
    protected readonly canManageOrganization: Signal<boolean> = computed(() =>
        this.organizationAccessPermissionsService.canAccessOrganization(),
    );
    protected readonly securityService = inject(SecurityService);

    private readonly organizationAccessPermissionsService = inject(OrganizationAccessPermissionsService);
    private router = inject(Router);

    public ngOnInit(): void {
        this.organization.set(this.securityService.meSignal()!.organization);
    }

    public redirectToManagementOrganizationPanel(): void {
        if (!this.canManageOrganization()) {
            return;
        }

        if (this.router.url.includes(RoutePathEnum.MANAGEMENT_ORGANIZATION)) {
            return;
        }

        this.router.navigate([RoutePathEnum.MANAGEMENT_ORGANIZATION]);
    }
}
